<template>
  <ag-modal-container
    :title="$t('multiproject.title.updateDraw')"
    fill-height
    @close="back"
  >
    <draw-form
      v-if="value"
      v-model="value"
      :draw-list="drawList"
      :disabled-default-options="isDisabledDefaultOptions"
      :data-table-loading="dataTableLoading"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-btn
        v-if="value"
        color="primary"
        class="mr-5"
        outlined
        @click="$options.downloadTemplate"
        v-text="$t('multiproject.template.download')"
      />
      <ag-upload-button
        v-if="value"
        color="primary"
        class="mr-5"
        outlined
        @upload="loadTemplate"
        v-text="$t('multiproject.template.upload')"
      />
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="accent"
        class="ml-5"
        @click="update"
        v-text="$t('general.update')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import AgUploadButton from 'src/components/common/AgUploadButton'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import { createEmptyDrawTemplate, readRoundListFromExcel } from 'src/services/drawExcelService'
import DrawForm from '../components/DrawForm'

export default {
  name: 'DrawUploadContainer',
  components: {
    AgModalContainer,
    AgUploadButton,
    DrawForm,
  },
  props: {
    drawId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    dataTableLoading: false,
    value: null,
    drawList: null,
    isDisabledDefaultOptions: false,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.drawList = await Repositories.multiProject.draw.getList()
        this.value = this.drawList.find(draw => draw.id === this.drawId)
        // Disable changes to default options if one is set
        if (this.value.defaultDraw) {
          this.isDisabledDefaultOptions = true
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async loadTemplate (file) {
      this.dataTableLoading = true
      try {
        const roundList = await readRoundListFromExcel(file)
        if (roundList.length !== 100) {
          this.showErrorNotification(this.$t('multiproject.template.uploadErrorLength'))
        }
        else {
          this.value = { ...this.value, roundList }
          this.showSuccessNotification(this.$t('multiproject.template.uploadSuccess'))
        }
      }
      catch (error) {
        this.showErrorNotification(this.$t('multiproject.template.uploadError'))
        throw error
      }
      finally {
        this.dataTableLoading = false
      }
    },
    async update () {
      this.loading = true
      try {
        await Repositories.multiProject.draw.patch(this.value)
        this.showSuccessNotification(this.$t('multiproject.fields.success.drawUpdated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
  downloadTemplate: createEmptyDrawTemplate,
}
</script>
